import { render, staticRenderFns } from "./NominateModal.vue?vue&type=template&id=78d62102&scoped=true&"
import script from "./NominateModal.vue?vue&type=script&lang=js&"
export * from "./NominateModal.vue?vue&type=script&lang=js&"
import style0 from "./NominateModal.vue?vue&type=style&index=0&id=78d62102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d62102",
  null
  
)

export default component.exports